import * as Yup from 'yup'

export const PreferencesSchema = Yup.object({
    radius : Yup.number()
        .required("INPUT.VALIDATION.RADIUS.REQUIRED")
        .min(1, "INPUT.VALIDATION.RADIUS.MINLIMIT")
        .max(100, "INPUT.VALIDATION.RADIUS.MAXLIMIT"),
    shift_type : Yup.string().required("INPUT.VALIDATION.SHIFT.TYPE.IS.REQUIRED"),
    min_hours: Yup.number()
        .required("INPUT.VALIDATION.MINHOURS.REQUIRED")
        .min(1, "INPUT.VALIDATION.MINHOURS.POSITIVE")
        .max(168, "INPUT.VALIDATION.MINHOURS.MAXLIMIT"),
    max_hours: Yup.number()
        .required("INPUT.VALIDATION.MAXHOURS.REQUIRED")
        .min(1, "INPUT.VALIDATION.MAXHOURS.POSITIVE")
        .max(168, "INPUT.VALIDATION.MAXHOURS.MAXLIMIT")
        .test(
            'min-less-than-max',
            "INPUT.VALIDATION.MAXHOURS.GREATERTHANMIN",
            function (value) {
                const { min_hours } = this.parent
                return value >= min_hours
            }
        ),
})
